export default {
  "seeVPNControl": "See VPN Control",
  "resolutionSimulatedDemoMode": "Resolution simulated (demo mode)",
  "resolutionApplied": "Resolution applied",
  "someStepsFailedChangesWereRolledBack": "Some steps failed — changes were rolled back.",
  "firewallSnapshotSavedBeforeChanges": "Firewall snapshot saved before changes.",
  "applyFailed": "Apply failed",
  "oneOrMoreStepsFailed": "One or more steps failed.",
  "affectedRules": "Affected rules",
  "affectedInterfaces": "Affected interfaces",
  "none": "(none)",
  "affectedServices": "Affected services",
  "affectedFirewallRules": "Affected firewall rules",
  "rulesContributingToThisConflict": "Rules contributing to this conflict",
  "resolutionChains": "Resolution chains",
  "pickOneChainToResolveThisConflict": "Pick one chain to resolve this conflict",
  "noAutomaticResolutionsAreAvailableForThisConflictReview": "No automatic resolutions are available for this conflict. Review the affected rules above and consider a manual fix.",
  "ifAThirdPartyDaemonEGPIARestarts": "If a third-party daemon (e.g. PIA) restarts after this fix, it may re-assert its rules. Use “Restore Previous Rules” on the firewall page to revert if that happens. There is no automated re-application path in v1.",
  "detectedFirewallConflicts": "Detected firewall conflicts",
  "clickAnyRowToReviewItsResolutionChainsConflicts": "Click any row to review its resolution chains. Conflicts are sorted by severity.",
  "noFirewallChangesInformationalOnly": "No firewall changes — informational only",
  "advisory": "Advisory",
  "rule": "rule",
  "openAdvisory": "Open advisory",
  "openResolver": "Open resolver",
  "thisJailIsSafeItWonTBanLegitimate": "This jail is safe — it won't ban legitimate users — but its filter is still being refined and may not yet catch every attack pattern for this app.",
  "thisJailSFilterHasBeenVerifiedToReliably": "This jail's filter has been verified to reliably catch brute-force attempts for this app.",
  "aSystemSecurityJailProtectsTheLshellRestrictedShell": "A system security jail — protects the lshell restricted shell that confines non-admin users, not an installable app.",
  "deploysTheShellConfinementJailConfigurationAndEnablesMonitoring": "Deploys the shell-confinement jail configuration and enables monitoring for lshell-confined users. Needed on installs upgraded before these jails existed.",
  "enabledButFail2banHasnTStartedWatchingItYet": "Enabled, but fail2ban hasn't started watching it yet — the jail loads once the app writes its first log line. Protection begins automatically then; no action needed.",
  "experimental": "Experimental",
  "verified": "Verified",
  "notActive": "Not active",
  "enabledAwaitingActivity": "Enabled — awaiting activity",
  "protected": "Protected",
  "shellSecurity": "Shell security",
  "shellConfinementMonitoringSetUp": "Shell-confinement monitoring set up",
  "theJailConfigurationWasDeployedAndMonitoringIsNow": "The jail configuration was deployed and monitoring is now active.",
  "failedToSetUpShellConfinementMonitoring": "Failed to set up shell-confinement monitoring",
  "shellConfinementMonitoring": "Shell confinement monitoring",
  "notSetUp": "Not set up",
  "setUpShellConfinementMonitoring": "Set up shell-confinement monitoring",
  "setUpMonitoring": "Set up monitoring",
  "loadingApplicationJails": "Loading application jails…",
  "noInstalledApplicationsOrSecuritySurfacesHaveAFail2ban": "No installed applications or security surfaces have a fail2ban jail template available on this system.",
  "applicationSecurityJails": "Application & Security Jails",
  "active": "active",
  "installedApplicationsAndShellConfinementSurfacesWithFail2banProtection": "Installed applications and shell-confinement surfaces with fail2ban protection available. Enabling a jail activates brute-force protection immediately — no system update required.",
  "applicationJails": "Application jails",
  "ownedByTheV3CLIReadOnlyInThe": "Owned by the v3 CLI — read-only in the dashboard",
  "ownedByTheV4Dashboard": "Owned by the v4 dashboard",
  "notFound": "Not found",
  "permissionDenied": "Permission denied",
  "truncatedAt64KB": "Truncated at 64 KB",
  "hide": "Hide",
  "show": "Show",
  "thisDropInIsWrittenWhenYouCustomizeA": "This drop-in is written when you customize a jail above. None has been created yet.",
  "thisFileIsNotPresentFail2banIsLikelyNot": "This file is not present — fail2ban is likely not installed, or it has not generated this file yet.",
  "noCustomJailOverridesYetTheseAreAddedWhen": "No custom jail overrides yet — these are added when you customize a jail above. The QuickBox base rules apply.",
  "theDashboardProcessCannotReadThisFileCheckFile": "The dashboard process cannot read this file. Check file permissions.",
  "fileExceeds64KBOnlyTheFirst64KB": "File exceeds 64 KB — only the first 64 KB is shown.",
  "configFiles": "Config Files",
  "loadingConfigFiles": "Loading config files...",
  "retry": "Retry",
  "noConfigFilesDeclaredForThisApplication": "No config files declared for this application.",
  "permanent": "Permanent",
  "banTime": "Ban Time",
  "findTime": "Find Time",
  "maxRetry": "Max Retry",
  "mustBeAnInteger": "Must be an integer",
  "mustBe1Or602592000": "Must be -1 or 60–2592000",
  "save": "Save",
  "cancel": "Cancel",
  "justNow": "just now",
  "noIPsCurrentlyBannedInThisJail": "No IPs currently banned in this jail.",
  "searchIPOrCountry": "Search IP or country…",
  "iP": "IP",
  "country": "Country",
  "banned": "Banned",
  "unban": "Unban",
  "active2": "Active",
  "disabled": "Disabled",
  "enforcedByFail2banRightNowALivePointIn": "Enforced by fail2ban right now — a live, point-in-time count. Falls to zero when a temporary ban expires or the service restarts.",
  "bannedNow": " banned now",
  "totalBansSinceFail2banLastStartedIncludingThoseThat": "Total bans since fail2ban last started, including those that have since expired. This counter resets to zero whenever the fail2ban service restarts — for the permanent record see the System Dashboard.",
  "collapse": "Collapse",
  "expand": "Expand",
  "thresholds": "Thresholds",
  "bannedIPs": "Banned IPs",
  "invalidIPOrCIDRFormat": "Invalid IP or CIDR format",
  "tooLong": "Too long",
  "failedToAddAllowlistEntry": "Failed to add allowlist entry",
  "allowlistIgnoreip": "Allowlist (ignoreip)",
  "remove": "Remove",
  "noCustomEntriesAddAnIPToPreventIt": "No custom entries. Add an IP to prevent it from being banned.",
  "addIPCIDR": "Add IP / CIDR",
  "add": "Add",
  "banFailed": "Ban failed",
  "unbanFailed": "Unban failed",
  "manualBanUnban": "Manual Ban / Unban",
  "banIP": "Ban IP",
  "iPAddress": "IP Address",
  "jail": "Jail",
  "unbanIP": "Unban IP",
  "removesTheIPFromAllJailsSimultaneously": "Removes the IP from all jails simultaneously.",
  "unbanFromAllJails": "Unban from All Jails",
  "fail2BanIsNotInstalled": "Fail2Ban is not installed",
  "fail2banMonitorsAuthenticationLogsAndAutomaticallyBansIPsWith": "Fail2ban monitors authentication logs and automatically bans IPs with too many failed login attempts. Install it via the Software page.",
  "fail2BanServiceIsNotRunning": "Fail2Ban service is not running",
  "theServiceIsInstalledButCurrentlyStoppedConfigurationIs": "The service is installed but currently stopped. Configuration is shown from the last known state. Start the service to activate protection.",
  "distinctIPsEverRecordedAsOffendersFromThePermanent": "Distinct IPs ever recorded as offenders. From the permanent security ledger — this count only ever goes up, even after bans expire or fail2ban restarts.",
  "iPsWithAnActivePermanentBanBanTime1": "IPs with an active permanent ban (ban time -1). Stays counted until an explicit unban is recorded — fail2ban purging its own state can never drop it.",
  "offendingIPsEverSeen": "Offending IPs ever seen",
  "allTimeNeverResets": "all-time, never resets",
  "permanentBans": "Permanent bans",
  "activeForeverBans1": "active forever bans (-1)",
  "removeYourOwnIPFromTheAllowlist": "Remove your own IP from the allowlist",
  "removeAnyway": "Remove anyway",
  "removeAllowlistEntry": "Remove allowlist entry",
  "failedToRemoveAllowlistEntry": "Failed to remove allowlist entry",
  "fail2banConfigurationReloaded": "Fail2ban configuration reloaded",
  "reloadFailed": "Reload failed",
  "loadingFail2banStatus": "Loading fail2ban status...",
  "running": "Running",
  "stopped": "Stopped",
  "reloadConfig": "Reload Config",
  "jails": "Jails",
  "noActiveJailsDetected": "No active jails detected.",
  "urgent": "Urgent",
  "recommended": "Recommended",
  "info": "Info",
  "appJail": "App Jail",
  "multiUser": "Multi-User",
  "behavioral": "Behavioral",
  "enableJail": "Enable jail",
  "review": "Review",
  "restoreRecommendation": "Restore recommendation",
  "restore": "Restore",
  "dismissRecommendation": "Dismiss recommendation",
  "noRecommendationsRightNowYourFail2banConfigurationLooksGood": "No recommendations right now — your fail2ban configuration looks good.",
  "allRecommendationsAreHidden": "All recommendations are hidden.",
  "failedToDismissRecommendation": "Failed to dismiss recommendation",
  "failedToRestoreRecommendation": "Failed to restore recommendation",
  "recommendations": "Recommendations",
  "hidden": "hidden",
  "loadingRecommendations": "Loading recommendations…",
  "hiddenRecommendations": "Hidden recommendations",
  "hidden2": "Hidden",
  "activeEnforcement": "Active Enforcement",
  "geoBlock": "Geo-Block",
  "geoBlockPolicyActive": "Geo-Block Policy Active",
  "firewallRuleFilters": "Firewall rule filters",
  "filterByProvider": "Filter by provider",
  "all": "All",
  "closeLabels": "Close Labels",
  "manageLabels": "Manage Labels",
  "filterBySeverity": "Filter by severity",
  "severity": "Severity:",
  "clearFilters": "Clear filters",
  "warning": "Warning",
  "critical": "Critical",
  "src": "src:",
  "dst": "dst:",
  "dport": "dport:",
  "enterLabelEGVpnRule": "Enter label (e.g. vpn-rule)",
  "ruleLabel": "Rule label",
  "saving": "Saving…",
  "editLabel": "Edit label",
  "labelThisRule": "Label this rule",
  "addIPToGeoBlockExemptions": "Add IP to geo-block exemptions",
  "removeThisFirewallRule": "Remove this firewall rule",
  "deleteRule": "Delete rule",
  "removing": "Removing...",
  "unknown": "Unknown",
  "firewallRuleRemoved": "Firewall rule removed",
  "failedToRemoveRule": "Failed to remove rule.",
  "failedToAddIPToExclusions": "Failed to add IP to exclusions.",
  "failedToRemoveRules": "Failed to remove rules.",
  "failedToUpdateLabel": "Failed to update label.",
  "cannotLabelThisRuleSignatureUnavailable": "Cannot label this rule — signature unavailable.",
  "quickHarden": "Quick Harden",
  "loadingProfiles": "Loading profiles…",
  "noHardeningProfilesAvailable": "No hardening profiles available.",
  "qBXENFORCEMENTChainActive": "QBX_ENFORCEMENT chain active",
  "qBXENFORCEMENTChainMissing": "QBX_ENFORCEMENT chain missing",
  "refreshFirewallRules": "Refresh firewall rules",
  "refresh": "Refresh",
  "hideFilters": "Hide filters",
  "showFilters": "Show filters",
  "searchRules": "Search rules...",
  "failedToApplyHardeningProfile": "Failed to apply hardening profile.",
  "alreadyAdded": "Already added",
  "invalidIPCIDRFormat": "Invalid IP/CIDR format",
  "iPCIDRTooLong": "IP/CIDR too long",
  "mustBeANumber": "Must be a number",
  "portMustBe165535": "Port must be 1-65535",
  "testIPAddress": "Test IP address",
  "test": "Test",
  "allowed": "Allowed",
  "blocked": "Blocked",
  "geoBlockDisabled": "Geo-block disabled",
  "geoBlockEnabled": "Geo-block enabled",
  "failedToUpdateCountries": "Failed to update countries",
  "failedToUpdateExemptIPs": "Failed to update exempt IPs",
  "failedToUpdateExemptPorts": "Failed to update exempt ports",
  "failedToTestIP": "Failed to test IP",
  "applyGeoBlockRules": "Apply geo-block rules",
  "thisWillActivateGeoBlockEnforcementRequestsFromRestricted": "This will activate geo-block enforcement. Requests from restricted countries will be denied and their IPs added to the firewall. Make sure your IP is exempt or in the allowlist to avoid lockout.",
  "applyRules": "Apply Rules",
  "geoBlockEnforcementActivated": "Geo-block enforcement activated",
  "disableGeoBlockEnforcement": "Disable geo-block enforcement",
  "thisWillStopBlockingRequestsBasedOnGeoBlock": "This will stop blocking requests based on geo-block policy. Previously added firewall rules will expire naturally.",
  "disable": "Disable",
  "geoBlockEnforcementDisabled": "Geo-block enforcement disabled",
  "loadingGeoBlockConfiguration": "Loading geo-block configuration...",
  "geoBlockEnforcementIsActiveIncomingRequestsAreChecked": "Geo-block enforcement is active. Incoming requests are checked against your country policy and denied if restricted. Blocked IPs are added to the firewall reactively.",
  "configureCountryLevelAccessRulesForTheServerSelect": "Configure country-level access rules for the server. Select countries and apply to activate enforcement.",
  "enforced": "Enforced",
  "notApplied": "Not Applied",
  "toggleGeoBlock": "Toggle geo-block",
  "configuration": "Configuration",
  "mode": "Mode",
  "blocklist": "Blocklist",
  "blockListedCountries": "Block listed countries",
  "allowlist": "Allowlist",
  "onlyAllowListedCountries": "Only allow listed countries",
  "exemptions": "Exemptions",
  "iPsCIDRs": "IPs / CIDRs",
  "safetyNet": "Safety Net",
  "alwaysAllowedRegardlessOfRulesAddYourAdminIP": "Always allowed regardless of rules. Add your admin IP to prevent lockout.",
  "addExemptIPCIDR": "Add exempt IP/CIDR",
  "ports": "Ports",
  "portsExcludedFromGeoBlockingEG22For": "Ports excluded from geo-blocking (e.g., 22 for SSH).",
  "addExemptPort": "Add exempt port",
  "testApply": "Test & Apply",
  "testIPAddress2": "Test IP Address",
  "checkIfAnIPWouldBeAllowedOrBlocked": "Check if an IP would be allowed or blocked by the current configuration.",
  "geoBlockEnforcementIsActive": "Geo-block enforcement is active",
  "incomingRequestsAreCheckedByCountryAndDeniedIf": "Incoming requests are checked by country and denied if restricted. Blocked IPs are added to the firewall as they connect.",
  "changesAreSavedAutomaticallyApplyToActivateEnforcement": "Changes are saved automatically. Apply to activate enforcement.",
  "disableEnforcement": "Disable Enforcement",
  "unnamedRule": "Unnamed Rule",
  "enabled": "Enabled",
  "s": "s",
  "autoBlock": "Auto-Block",
  "editRule": "Edit rule",
  "ruleUpdated": "Rule updated",
  "ruleCreated": "Rule created",
  "failedToUpdateRule": "Failed to update rule",
  "failedToCreateRule": "Failed to create rule",
  "ruleDisabled": "Rule disabled",
  "ruleEnabled": "Rule enabled",
  "failedToToggleRule": "Failed to toggle rule",
  "deleteGeoLockRule": "Delete geo-lock rule",
  "delete": "Delete",
  "ruleDeleted": "Rule deleted",
  "failedToDeleteRule": "Failed to delete rule",
  "loadingGeoLockRules": "Loading geo-lock rules...",
  "restrictMediaStreamingAccessBasedOnGeographicLocationIP": "Restrict media streaming access based on geographic location, IP ranges, and user/device scope.",
  "addRule": "Add Rule",
  "noGeoLockRulesConfigured": "No geo-lock rules configured.",
  "alert": "Alert",
  "softBlock": "Soft Block",
  "hardBlock": "Hard Block",
  "graceStarted": "Grace Started",
  "warningSent": "Warning Sent",
  "killed": "Killed",
  "graceCleared": "Grace Cleared",
  "noViolationsRecorded": "No violations recorded.",
  "time": "Time",
  "user": "User",
  "action": "Action",
  "vPNConnectionDetected": "VPN connection detected",
  "proxyConnectionDetected": "Proxy connection detected",
  "proxy": "Proxy",
  "torExitNodeDetected": "Tor exit node detected",
  "hostingDatacenterIP": "Hosting/datacenter IP",
  "hosting": "Hosting",
  "ban": "Ban",
  "offense": "Offense",
  "permanentBan": "Permanent ban",
  "currentlyBanned2": "Currently banned",
  "notCurrentlyBanned": "Not currently banned",
  "bans": "Bans",
  "offenses": "Offenses",
  "firstSeen": "First seen",
  "lastSeen": "Last seen",
  "banTime2": "ban time:",
  "attempts": "attempts:",
  "threatDetail": "Threat detail",
  "loadingThreatDetail": "Loading threat detail…",
  "noRecordedEventsForThisIPYet": "No recorded events for this IP yet.",
  "baseDefault": "(base default)",
  "lockedFields": "Locked fields",
  "readOnly": "read-only",
  "renderedVerbatimFromTheBaseConfigAndNeverEditable": "Rendered verbatim from the base config and never editable — the logging keys are pinned by the fail2ban filter contract, and the path keys are the confinement boundary that keeps a restricted user in their home directory.",
  "empty": "(empty)",
  "current": "current",
  "proposed": "proposed",
  "restrictedShellIsNotAvailable": "Restricted shell is not available",
  "noEffectiveChangesToApply": "No effective changes to apply",
  "applyRestrictedShellPolicy": "Apply restricted-shell policy",
  "applyPolicy": "Apply policy",
  "policyNotApplied": "Policy not applied",
  "restrictedShellPolicyApplied": "Restricted-shell policy applied",
  "policySaved": "Policy saved",
  "resetToBaseConfig": "Reset to base config",
  "thisClearsEveryDashboardOverrideAndReRendersEtc": "This clears every dashboard override and re-renders /etc/lshell.conf from the untouched base config. All editable fields return to their base defaults. This cannot be undone.",
  "resetToBase": "Reset to base",
  "resetFailed": "Reset failed",
  "loadingRestrictedShellPolicy": "Loading restricted-shell policy...",
  "lshellIsNotInstalledOnThisServer": "lshell is not installed on this server.",
  "revertThisFieldToItsBaseDefault": "Revert this field to its base default",
  "base": "Base",
  "controlsTheWhitelistedCommandSetForShellLevel3": "Controls the whitelisted command set for shell-level-3 users confined by the restricted shell. Overrides are stored in the database and re-applied on every update.",
  "baseConfigNoOverrides": "Base config (no overrides)",
  "youHaveReadOnlyAccessToTheRestrictedShell": "You have read-only access to the restricted-shell policy.",
  "commandPolicy": "Command policy",
  "allowedCommands": "Allowed commands",
  "addAnAllowedCommand": "Add an allowed command...",
  "forbiddenTokens": "Forbidden tokens",
  "addAForbiddenToken": "Add a forbidden token...",
  "forbiddenMustNotBeEmpty": "Forbidden must not be empty.",
  "allowedOverSSHOverssh": "Allowed over SSH (overssh)",
  "addACommandPermittedOverSSH": "Add a command permitted over SSH...",
  "commandsAllowedOverSSH": "Commands allowed over SSH",
  "mustBeASubsetOfTheAllowedCommandsAbove": "Must be a subset of the allowed commands above.",
  "restrictionsLimits": "Restrictions & limits",
  "warningCounter": "Warning counter",
  "maxProcesses": "Max processes",
  "loginIntro": "Login intro",
  "messageShownWhenARestrictedUserLogsIn": "Message shown when a restricted user logs in...",
  "loginIntroMessage": "Login intro message",
  "commandAliases": "Command aliases",
  "noAliasesAnAliasMapsAFriendlyNameTo": "No aliases. An alias maps a friendly name to an allowed command.",
  "addAlias": "Add alias",
  "policyRejectedFixTheFollowing": "Policy rejected — fix the following:",
  "clearsEveryOverrideAndReRendersFromTheBase": "Clears every override and re-renders from the base config",
  "previewApply": "Preview & Apply",
  "localOnly": "(local only)",
  "manageCustomLabels": "Manage custom labels",
  "customLabels": "Custom Labels",
  "closeManageLabelsPanel": "Close Manage Labels panel",
  "noCustomLabelsAppliedYetUseTheTagIcon": "No custom labels applied yet. Use the tag icon on any rule row to add a label.",
  "quickBoxRules": "QuickBox rules",
  "externalRulesLocalOnly": "External rules (local only)",
  "expired": "Expired",
  "confirm": "Confirm",
  "extendDuration": "Extend duration",
  "deleteBlock": "Delete block",
  "blockAdded": "Block added",
  "failedToAddBlock": "Failed to add block",
  "blockConfirmed": "Block confirmed",
  "rollbackTimerCancelledRulePersistedToDisk": "Rollback timer cancelled. Rule persisted to disk.",
  "failedToConfirmBlock": "Failed to confirm block",
  "deleteNetworkBlock": "Delete network block",
  "blockDeleted": "Block deleted",
  "failedToDeleteBlock": "Failed to delete block",
  "blockExtended": "Block extended",
  "expirationExtendedBy24Hours": "Expiration extended by 24 hours.",
  "failedToExtendBlock": "Failed to extend block",
  "loadingEnforcementBlocks": "Loading enforcement blocks...",
  "iPCIDR": "IP / CIDR",
  "reason": "Reason",
  "eGBruteForceAttempt": "e.g. Brute force attempt",
  "duration": "Duration",
  "block": "Block",
  "noNetworkEnforcementBlocksConfigured": "No network enforcement blocks configured.",
  "searchByIPCIDROrReason": "Search by IP / CIDR or reason…",
  "searchActiveBlocks": "Search active blocks",
  "clearSearch": "Clear search",
  "noBlocksMatch": "No blocks match “{{query}}”.",
  "repeat": "Repeat",
  "applyingThisChainMayCutOffYourDashboardSession": "Applying this chain may cut off your dashboard session. Confirm below before applying.",
  "lockoutRisk": "Lockout risk",
  "informational": "Informational",
  "service": "Service:",
  "predictedRuleCountChangeByProvider": "Predicted rule count change by provider",
  "predictedRuleCountChange": "Predicted rule count change",
  "lockoutWarning": "Lockout warning",
  "iUnderstandApplyingThisChainMayInterruptMyDashboard": "I understand applying this chain may interrupt my dashboard session.",
  "demoModeApplyWillBeSimulatedAndNoFirewall": "Demo mode — apply will be simulated and no firewall rules will change.",
  "dismissAdvisory": "Dismiss advisory",
  "nothingToApplyThisChainIsInformationalOnly": "Nothing to apply — this chain is informational only.",
  "running2": "Running…",
  "reRunPreview": "Re-run preview",
  "preview": "Preview",
  "applying": "Applying…",
  "applied": "Applied",
  "apply": "Apply",
  "left": "left",
  "tokenExpiredReRunPreviewToApply": "Token expired — re-run preview to apply.",
  "snapshotDryRunNotYetAvailableTryRestoreDirectly": "Snapshot dry-run not yet available — try Restore directly.",
  "snapshotPreviewFailed": "Snapshot preview failed.",
  "networkErrorPreviewingSnapshot": "Network error previewing snapshot.",
  "runPreviewBeforeRestoringThisSnapshot": "Run preview before restoring this snapshot.",
  "previewTokenExpiredReRunPreviewToRestore": "Preview token expired — re-run preview to restore.",
  "snapshotRestored": "Snapshot restored",
  "firewallRulesResetToTheChosenSnapshot": "Firewall rules reset to the chosen snapshot.",
  "restoreFailed": "Restore failed",
  "loadingFirewallSnapshots": "Loading firewall snapshots…",
  "restorePreviousFirewallRules": "Restore previous firewall rules",
  "restorePreviousRules": "Restore previous rules",
  "refreshSnapshotList": "Refresh snapshot list",
  "eachSuccessfulResolutionApplyWritesASnapshotFirstIf": "Each successful resolution apply writes a snapshot first. If a third-party daemon re-asserts its rules, restore the most recent snapshot to get back to a known good state. Restore is dry-run gated.",
  "previewing": "Previewing",
  "restoring": "Restoring",
  "usernameDisallowed": "Username disallowed",
  "failedToAddUsername": "Failed to add username",
  "failedToRemoveUsernames": "Failed to remove usernames",
  "iPBanned": "IP banned",
  "failedToBanIP": "Failed to ban IP",
  "loadingSecuritySettings": "Loading security settings...",
  "youHaveReadOnlyAccessToSecuritySettings": "You have read-only access to security settings.",
  "disallowedUsernames": "Disallowed Usernames",
  "usernamesBlockedAtTheServerLevelDuringRegistrationAnd": "Usernames blocked at the server level during registration and login",
  "username": "Username",
  "optional": "(optional)",
  "eGReservedSystemName": "e.g. Reserved system name",
  "serverEnforcedAtRegistrationAndLogin": "Server-enforced at registration and login",
  "noDisallowedUsernamesConfigured": "No disallowed usernames configured.",
  "clear": "Clear",
  "disallowedUsernames2": "Disallowed usernames",
  "iPAddressesBlockedAtApplicationLevelAndEnforcedWith": "IP addresses blocked at application level and enforced with iptables firewall rules",
  "eGRepeatedAbuse": "e.g. Repeated abuse",
  "topOffenders": "Top Offenders",
  "allTimeRankedOffendersFromThePermanentSecurityLedger": "All-time ranked offenders from the permanent security ledger — never decays",
  "networkEnforcement": "Network Enforcement",
  "manageIptablesLevelIPCIDRBlocksViaTheQBX": "Manage iptables-level IP/CIDR blocks via the QBX_ENFORCEMENT chain",
  "perm": "Perm",
  "bans2": "bans",
  "rankedFromThePermanentSecurityLedgerNeverDecays": "Ranked from the permanent security ledger — never decays.",
  "currentlyBannedOnly": "Currently banned only",
  "exportCSV": "Export CSV",
  "loadingOffenders": "Loading offenders…",
  "noOffendersRecorded": "No offenders recorded",
  "noIPsAreCurrentlyBanned": "No IPs are currently banned.",
  "noIPsHaveTriggeredASecurityEventYet": "No IPs have triggered a security event yet.",
  "currentlyBanned3": " (currently banned)",
  "manual": "Manual",
  "removeBan": "Remove ban",
  "past": "Past",
  "searchIPCountryOrJail": "Search IP, country, or jail…",
  "searchBannedIPs": "Search banned IPs",
  "filterBySource": "Filter by source",
  "allSources": "All sources",
  "manualOnly": "Manual only",
  "fail2banOnly": "Fail2ban only",
  "allCountries": "All countries",
  "filterByJail": "Filter by jail",
  "allJails": "All jails",
  "activeOnly": "Active only",
  "iPRemovedFromBanList": "IP removed from ban list",
  "failedToRemoveBan": "Failed to remove ban",
  "status": "Status",
  "loadingBannedIPs": "Loading banned IPs…",
  "noBannedIPs": "No banned IPs",
  "applyFailed2": "Apply failed.",
  "networkErrorApplyingResolution": "Network error applying resolution.",
  "dryRunFailed": "Dry-run failed.",
  "networkErrorRunningDryRun": "Network error running dry-run.",
  "youDonTHavePermissionToViewFirewallConflicts": "You don't have permission to view firewall conflicts.",
  "firewallConflictDetectionUnavailable": "Firewall conflict detection unavailable.",
  "failedToLoadFirewallConflicts": "Failed to load firewall conflicts.",
  "networkErrorLoadingFirewallConflicts": "Network error loading firewall conflicts.",
  "youDonTHavePermissionToViewFirewallSnapshots": "You don't have permission to view firewall snapshots.",
  "failedToLoadFirewallSnapshots": "Failed to load firewall snapshots.",
  "networkErrorLoadingFirewallSnapshots": "Network error loading firewall snapshots.",
  "snapshotRestoreFailed": "Snapshot restore failed.",
  "networkErrorRestoringSnapshot": "Network error restoring snapshot.",
  "failedToLoadIPHistory": "Failed to load IP history.",
  "networkError": "Network error.",
  "failedToLoadIPThreatDetail": "Failed to load IP threat detail.",
  "failedToLoadOffenderRollups": "Failed to load offender rollups.",
  "failedToLoadSecurityStats": "Failed to load security stats.",
  "failedToLoadOffenders": "Failed to load offenders.",
  "competingVPNKillswitches": "Competing VPN killswitches",
  "quickBoxWireGuardUnderlayBlocked": "QuickBox WireGuard underlay blocked",
  "staleInterfaceReference": "Stale interface reference",
  "perAppRoutingBlockedByHostKillswitch": "Per-app routing blocked by host killswitch",
  "dNSLeakVsDNSLockConflict": "DNS leak vs DNS lock conflict",
  "catchAllREJECTInThirdPartyChain": "Catch-all REJECT in third-party chain",
  "wireGuardSystem": "WireGuard (system)",
  "pending": "Pending",
  "removed": "Removed",
  "rolledBack": "Rolled Back",
  "banList": "Ban List",
  "geoPolicy": "Geo Policy",
  "system": "System",
  "youDonTHavePermissionToViewFail2banSettings": "You don't have permission to view fail2ban settings.",
  "failedToLoadFail2banStatus": "Failed to load fail2ban status.",
  "toggleFailed": "Toggle failed.",
  "failedToAddAllowlistEntry2": "Failed to add allowlist entry.",
  "failedToRemoveAllowlistEntry2": "Failed to remove allowlist entry.",
  "banFailed2": "Ban failed.",
  "unbanFailed2": "Unban failed.",
  "reloadFailed2": "Reload failed.",
  "failedToLoadApplicationJails": "Failed to load application jails.",
  "setupFailed": "Setup failed.",
  "failedToLoadSuggestions": "Failed to load suggestions.",
  "dismissFailed": "Dismiss failed.",
  "failedToLoadConfigFiles": "Failed to load config files",
  "networkErrorLoadingConfigFiles": "Network error loading config files",
  "youDonTHavePermissionToViewFirewallRules": "You don't have permission to view firewall rules.",
  "firewallAccessUnavailableCheckServerPermissions": "Firewall access unavailable. Check server permissions.",
  "firewallAccessUnavailableEnsurePasswordlessSudoForIptablesIs": "Firewall access unavailable. Ensure passwordless sudo for iptables is configured.",
  "failedToLoadFirewallRules": "Failed to load firewall rules.",
  "failedToLoadFirewallData": "Failed to load firewall data.",
  "iPAlreadyInExclusions": "IP already in exclusions.",
  "failedToLabelRule": "Failed to label rule.",
  "failedToLabelForeignRule": "Failed to label foreign rule.",
  "failedToRemoveForeignLabel": "Failed to remove foreign label.",
  "failedToRenameLabel": "Failed to rename label.",
  "failedToRemoveLabel": "Failed to remove label.",
  "youDonTHavePermissionToViewGeoBlock": "You don't have permission to view geo-block settings.",
  "failedToLoadGeoBlockConfiguration": "Failed to load geo-block configuration.",
  "failedToUpdateConfiguration": "Failed to update configuration.",
  "failedToApplyRules": "Failed to apply rules",
  "failedToDisableEnforcement": "Failed to disable enforcement.",
  "failedToTestIP2": "Failed to test IP.",
  "youDonTHavePermissionToViewTheRestricted": "You don't have permission to view the restricted-shell policy.",
  "failedToLoadTheRestrictedShellPolicy": "Failed to load the restricted-shell policy.",
  "previewFailed": "Preview failed.",
  "previewRequestFailed": "Preview request failed.",
  "applyRequestFailed": "Apply request failed.",
  "youDonTHavePermissionToViewNetworkEnforcement": "You don't have permission to view network enforcement settings.",
  "failedToLoadEnforcementBlocks": "Failed to load enforcement blocks.",
  "failedToLoadNetworkEnforcementData": "Failed to load network enforcement data.",
  "failedToAddBlock2": "Failed to add block.",
  "failedToRemoveBlock": "Failed to remove block.",
  "failedToConfirmBlock2": "Failed to confirm block.",
  "failedToExtendBlock2": "Failed to extend block.",
  "youDonTHavePermissionToViewSecuritySettings": "You don't have permission to view security settings.",
  "failedToLoadSecuritySettings": "Failed to load security settings.",
  "failedToAddUsername2": "Failed to add username.",
  "failedToRemoveUsername": "Failed to remove username.",
  "failedToAddIP": "Failed to add IP.",
  "failedToRemoveIP": "Failed to remove IP.",
  "securitySettings": "Security Settings",
  "firewallRules": "Firewall Rules",
  "geoLock": "Geo-Lock",
  "restrictedShell": "Restricted Shell",
  "manageDisallowedUsernamesIPBansNetworkEnforcementFirewallRules": "Manage disallowed usernames, IP bans, network enforcement, firewall rules, and fail2ban.",
  "securitySettingsTabs": "Security settings tabs",
  "joinCountMore": "{{join}} +{{count}} more",
  "openAdvisorySummary": "Open advisory {{summary}}",
  "openResolverForSummary": "Open resolver for {{summary}}",
  "mustBeMinMax": "Must be {{min}}–{{max}}",
  "editLabel2": "Edit {{label}}",
  "searchBannedIPsInJailName": "Search banned IPs in {{jailName}}",
  "unbanIp": "Unban {{ip}}",
  "trimmedIsAlreadyInTheAllowlist": "{{trimmed}} is already in the allowlist",
  "addedTrimmedToAllowlist": "Added {{trimmed}} to allowlist",
  "removeEntryFromAllowlist": "Remove {{entry}} from allowlist",
  "bannedIpInJail": "Banned {{ip}} in {{jail}}",
  "unbannedIpFromAllJails": "Unbanned {{ip}} from all jails",
  "ipCoversYourCurrentConnectionClientIpRemovingItMeansFail2ban": "\"{{ip}}\" covers your current connection ({{clientIp}}). Removing it means fail2ban can ban the IP you are managing the dashboard from if you exceed any jail threshold. Make sure you have an alternative way in before continuing.",
  "removeIpFromTheFail2banAllowlistIfThisIsYour": "Remove \"{{ip}}\" from the fail2ban allowlist? If this is your current IP address, fail2ban may ban you if you exceed the threshold for any jail. Make sure you have an alternative way in before confirming.",
  "removedIpFromAllowlist": "Removed {{ip}} from allowlist",
  "updatedFieldForJail": "Updated {{field}} for {{jail}}",
  "failedToUpdateField": "Failed to update {{field}}",
  "unbannedIp": "Unbanned {{ip}}",
  "jailJailEnabled": "{{jail}} jail enabled",
  "failedToEnableJail": "Failed to enable {{jail}}",
  "updatedFieldForJailToSuggestedValue": "Updated {{field}} for {{jail}} to {{suggestedValue}}",
  "showHiddenCount": "Show {{hiddenCount}}",
  "selectRuleRuleText": "Select rule {{ruleText}}",
  "editLabelUserLabel": "Edit label: {{userLabel}}",
  "exemptValueFromGeoBlocking": "Exempt {{value}} from geo-blocking",
  "addedCleanIpToGeoBlockExemptions": "Added {{cleanIp}} to geo-block exemptions",
  "removeItem": "Remove {{item}}",
  "userUsername": "user: {{username}}",
  "deviceDeviceId": "device: {{deviceId}}",
  "toggleRule": "Toggle {{rule}}",
  "editRule2": "Edit {{rule}}",
  "deleteRule2": "Delete {{rule}}",
  "deleteValueThisActionCannotBeUndone": "Delete \"{{value}}\"? This action cannot be undone.",
  "revertKeyToBaseDefault": "Revert {{key}} to base default",
  "aliasNameIdx": "Alias name {{idx}}",
  "aliasCommandIdx": "Alias command {{idx}}",
  "removeAliasIdx": "Remove alias {{idx}}",
  "renameLabelLabel": "Rename label {{label}}",
  "removeLabelLabel": "Remove label {{label}}",
  "failedToRenameOldLabel": "Failed to rename \"{{oldLabel}}\".",
  "failedToRemoveLabelLabel": "Failed to remove label \"{{label}}\".",
  "renamedPartiallyFailedOfLengthFailed": "Renamed partially — {{failed}} of {{length}} failed.",
  "removedPartiallyFailedOfLengthFailed": "Removed partially — {{failed}} of {{length}} failed.",
  "extendBlockForIpCidr": "Extend block for {{ipCidr}}",
  "exemptIpCidrFromGeoBlocking": "Exempt {{ipCidr}} from geo-blocking",
  "removeBlockForIpCidr": "Remove block for {{ipCidr}}",
  "removeTheIptablesRuleBlockingValueAndDeleteTheBlock": "Remove the iptables rule blocking {{value}} and delete the block record? The rule will be removed immediately.",
  "deleteTheBlockRecordForValueAnyAssociatedIptablesRule": "Delete the block record for {{value}}? Any associated iptables rule will also be cleaned up.",
  "addedIpToGeoBlockExemptions": "Added {{ip}} to geo-block exemptions",
  "repeatOffenderJoin": "Repeat offender — {{join}}",
  "titleRecommended": "{{title}} (recommended)",
  "actionsForTitle": "Actions for {{title}}",
  "trimmedAddedToTheBlockList": "\"{{trimmed}}\" added to the block list.",
  "failedToRemoveLengthOfLength2Usernames": "Failed to remove {{length}} of {{length2}} usernames",
  "trimmedAddedToTheBanList": "{{trimmed}} added to the ban list.",
  "hideHistoryForIp": "Hide history for {{ip}}",
  "showHistoryForIp": "Show history for {{ip}}",
  "removeBanForIp": "Remove ban for {{ip}}",
  "failedToSetField": "Failed to set {{field}}.",
  "configJail": "Config Jail",
  "hideDismissedRecommendations": "Hide dismissed recommendations",
  "thisRuleHasExpiredAndIsPendingCleanup": "This rule has expired and is pending cleanup",
  "thisRuleWasRemovedAndIsPendingCleanup": "This rule was removed and is pending cleanup",
  "thisRuleWasRolledBackAndIsPendingCleanup": "This rule was rolled back and is pending cleanup",
  "noFirewallRulesFoundTheIptablesServiceMayNotBe": "No firewall rules found. The iptables service may not be running.",
  "noRulesMatchTheCurrentFilter": "No rules match the current filter.",
  "labelRemoved": "Label removed.",
  "nftablesBackend": "nftables backend",
  "legacyBackend": "legacy backend",
  "blockedCountries": "Blocked Countries",
  "allowedCountries": "Allowed Countries",
  "noCountriesBlockedAddCountriesToBlockTheirConnections": "No countries blocked. Add countries to block their connections.",
  "noCountriesAllowedAddCountriesToAllowTheirConnections": "No countries allowed. Add countries to allow their connections.",
  "on1": "on (1)",
  "off0": "off (0)",
  "permitScpFileTransfer": "Permit scp file transfer",
  "permitSftpFileTransfer": "Permit sftp file transfer",
  "repeatOffenderBannedMoreThanOnce": "Repeat offender — banned more than once",
  "youDonTHavePermissionToViewIPHistory": "You don't have permission to view IP history.",
  "youDonTHavePermissionToViewIPThreatDetail": "You don't have permission to view IP threat detail.",
  "youDonTHavePermissionToViewSecurityStats": "You don't have permission to view security stats.",
  "youDonTHavePermissionToViewOffenders": "You don't have permission to view offenders.",
  "totalCount": "{{count}} total",
  "ruleCount": "{{count}} rules",
  "ruleCount_one": "{{count}} rule",
  "ruleCount_other": "{{count}} rules",
  "moreCount": "+{{count}} more",
  "activeCount": "{{active}} / {{total}} active",
  "fileCount": "{{count}} files",
  "fileCount_one": "{{count}} file",
  "fileCount_other": "{{count}} files",
  "noIpsMatch": "No IPs match “{{query}}”.",
  "sinceRestartCount": "{{count}} since restart",
  "jailCount": "{{count}} jails",
  "jailCount_one": "{{count}} jail",
  "jailCount_other": "{{count}} jails",
  "currentlyBannedCount": "{{count}} currently banned",
  "dropRuleCount": "{{count}} active DROP rules in QBX_ENFORCEMENT",
  "dropRuleCount_one": "{{count}} active DROP rule in QBX_ENFORCEMENT",
  "dropRuleCount_other": "{{count}} active DROP rules in QBX_ENFORCEMENT",
  "protocolValue": "Protocol: {{protocol}}",
  "conflictError": "Conflict detection: {{error}}",
  "activeFilters": ", {{count}} active",
  "graceSeconds": "Grace: {{seconds}}",
  "eventCount": "{{count}} events",
  "eventCount_one": "{{count}} event",
  "eventCount_other": "{{count}} events",
  "recentEvents": "Showing the {{shown}} most recent of {{total}} events.",
  "fieldsWillChange": "{{count}} fields will change. Review before applying.",
  "fieldsWillChange_one": "{{count}} field will change. Review before applying.",
  "fieldsWillChange_other": "{{count}} fields will change. Review before applying.",
  "fieldsOverridden": "{{count}} fields overridden",
  "fieldsOverridden_one": "{{count}} field overridden",
  "fieldsOverridden_other": "{{count}} fields overridden",
  "warningCounterHelp": "{{min}}–{{max}}. Warnings before the session is closed on forbidden input.",
  "maxProcessesHelp": "{{off}} to disable, or {{min}}–{{max}} as the per-user process ceiling.",
  "introLengthHelp": "Up to {{count}} characters. Shown to the user at login.",
  "introLengthHelp_one": "Up to {{count}} character. Shown to the user at login.",
  "introLengthHelp_other": "Up to {{count}} characters. Shown to the user at login.",
  "labelCount": "({{count}} labels)",
  "labelCount_one": "({{count}} label)",
  "labelCount_other": "({{count}} labels)",
  "rollbackIn": "Auto-rollback in {{time}}",
  "createdAt": "Created {{date}}",
  "expiresAt": "Expires: {{date}}",
  "removesRules": "Removes {{count}} rules",
  "removesRules_one": "Removes {{count}} rule",
  "removesRules_other": "Removes {{count}} rules",
  "addsRules": "Adds {{count}} rules",
  "addsRules_one": "Adds {{count}} rule",
  "addsRules_other": "Adds {{count}} rules",
  "dryRunErrorValue": "Dry-run error: {{error}}",
  "applyErrorValue": "Apply error: {{error}}",
  "applyTokenLeft": "Apply token: {{time}} left",
  "lastCount": "Last {{count}}",
  "conflictId": "Conflict {{id}}",
  "selectedCount": "{{count}} selected",
  "firstSeenValue": "First seen: {{time}}",
  "lastSeenValue": "Last seen: {{time}}",
  "experimentalJailHint": "Experimental jail. {{hint}}",
  "verifiedJailHint": "Verified jail. {{hint}}",
  "jailEnabled": "{{jail}} jail enabled",
  "jailDisabled": "{{jail}} jail disabled",
  "protectionActive": "{{subject}} protection is now active.",
  "protectionInactive": "{{subject}} protection is now inactive.",
  "jailEnableFailed": "Failed to enable {{jail}} jail",
  "jailDisableFailed": "Failed to disable {{jail}} jail",
  "disableAppJail": "Disable fail2ban jail for {{jail}}",
  "enableAppJail": "Enable fail2ban jail for {{jail}}",
  "awaitingActivityHint": "Enabled, awaiting activity. {{hint}}",
  "shellJailHint": "Shell security jail. {{hint}}",
  "hideFileContent": "Hide content for {{file}}",
  "showFileContent": "Show content for {{file}}",
  "disableJail": "Disable {{jail}} jail",
  "ledgerBanHint": "Ban events for this jail in the last {{window}}, from the permanent security ledger. Retained even after fail2ban expires a ban or restarts — so this can be non-zero while the live count reads 0.",
  "ledgerWindow": " in {{window}} · ledger",
  "timeWindow": "time window",
  "blocklistSet": "Mode set to blocklist",
  "allowlistSet": "Mode set to allowlist",
  "removedUsernames": "Removed {{count}} usernames from block list",
  "removedUsernames_one": "Removed {{count}} username from block list",
  "removedUsernames_other": "Removed {{count}} usernames from block list",
  "enableJailNamed": "Enable {{jail}} jail",
  "wireGuardTunnels": "WireGuard active: {{count}} tunnels {{names}}",
  "wireGuardTunnels_one": "WireGuard active: {{count}} tunnel {{names}}",
  "wireGuardTunnels_other": "WireGuard active: {{count}} tunnels {{names}}",
  "allowlistHelp": "IPs and CIDRs in this list are never banned by any jail. {{ipv4}} and {{ipv6}} are permanent and cannot be removed.",
  "noJailConfig": "Fail2ban is running but no jails are configured. Check {{path}}.",
  "geoPolicySummary": "{{policy}}",
  "geoBlockSummary": "Blocking requests from {{count}} countries. IPs are blocked reactively as they connect — individual DROP rules appear below as traffic is intercepted.",
  "geoBlockSummary_one": "Blocking requests from {{count}} country. IPs are blocked reactively as they connect — individual DROP rules appear below as traffic is intercepted.",
  "geoBlockSummary_other": "Blocking requests from {{count}} countries. IPs are blocked reactively as they connect — individual DROP rules appear below as traffic is intercepted.",
  "geoAllowSummary": "Allowing only requests from {{count}} countries. IPs are blocked reactively as they connect — individual DROP rules appear below as traffic is intercepted.",
  "geoAllowSummary_one": "Allowing only requests from {{count}} country. IPs are blocked reactively as they connect — individual DROP rules appear below as traffic is intercepted.",
  "geoAllowSummary_other": "Allowing only requests from {{count}} countries. IPs are blocked reactively as they connect — individual DROP rules appear below as traffic is intercepted.",
  "foreignRuleHelp": "This rule is managed outside QuickBox ({{provider}}{{chain}} chain). Your label is stored locally and will not appear in {{command}}.",
  "rulesShown": "Showing {{shown}} of {{count}} rules{{removable}}",
  "rulesShown_one": "Showing {{shown}} of {{count}} rule{{removable}}",
  "rulesShown_other": "Showing {{shown}} of {{count}} rules{{removable}}",
  "removableCount": " — {{count}} removable",
  "adminAddress": "Detected admin IP: {{ip}} (port {{port}})",
  "exemptCurrentIp": "Add my current IP {{ip}} to the geo-block exempt list before applying",
  "tokenExpiresInTime": "Token expires in {{time}}",
  "offendersSummary": "{{summary}}{{active}}",
  "topOffendersCount": "Top {{shown}} of {{count}} offenders",
  "offenderCount": "{{count}} offenders",
  "offenderCount_one": "{{count}} offender",
  "offenderCount_other": "{{count}} offenders",
  "totalBanRecords": "{{count}} total ban records{{filtered}}",
  "totalBanRecords_one": "{{count}} total ban record{{filtered}}",
  "totalBanRecords_other": "{{count}} total ban records{{filtered}}",
  "filteredSuffix": " (filtered)",
  "missingTokens_one": "Missing required token: {{tokens}}",
  "missingTokens_other": "Missing required tokens: {{tokens}}",
  "allowedCommandsHelp": "Commands a restricted user may run. Never allowed: {{tokens}} — each grants an interactive shell or shell escape.",
  "bannedCommandsHelp": "Remove {{tokens}} — a shell here defeats the confinement and will be rejected.",
  "requiredTokensHelp": "Must retain: {{tokens}} — these block chaining, piping, redirection, subshells and privilege escalation.",
  "missingTokens": "Missing required tokens: {{tokens}}",
  "notAllowedHelp": "Not in allowed: {{tokens}} — add them to allowed or remove them here.",
  "bannedIpsCount": "{{count}} Banned IPs",
  "bannedIpsCount_one": "{{count}} Banned IP",
  "bannedIpsCount_other": "{{count}} Banned IPs",
  "geoBlocksCount": "{{count}} Geo-Blocks",
  "geoBlocksCount_one": "{{count}} Geo-Block",
  "geoBlocksCount_other": "{{count}} Geo-Blocks",
  "manualBlocksCount": "{{count}} Manual Blocks",
  "manualBlocksCount_one": "{{count}} Manual Block",
  "manualBlocksCount_other": "{{count}} Manual Blocks",
  "recentViolations": "{{count}} recent violations",
  "recentViolations_one": "{{count}} recent violation",
  "recentViolations_other": "{{count}} recent violations",
  "historicalBlocksCount": "{{count}} historical blocks",
  "historicalBlocksCount_one": "{{count}} historical block",
  "historicalBlocksCount_other": "{{count}} historical blocks",
  "stepsCount": "{{count}} steps",
  "stepsCount_one": "{{count}} step",
  "stepsCount_other": "{{count}} steps",
  "hideSteps": "Hide steps",
  "showSteps": "Show steps",
  "pinnedCount": "{{count}} pinned",
  "removeSelectedCount": "Remove Selected ({{count}})",
  "setThresholdValue": "Set {{field}} to {{value}}",
  "showDismissedCount": "Show {{count}} dismissed recommendations",
  "showDismissedCount_one": "Show {{count}} dismissed recommendation",
  "showDismissedCount_other": "Show {{count}} dismissed recommendations",
  "hideRecommendationsCount": "{{count}} hidden recommendations — click to hide",
  "hideRecommendationsCount_one": "{{count}} hidden recommendation — click to hide",
  "hideRecommendationsCount_other": "{{count}} hidden recommendations — click to hide",
  "showRecommendationsCount": "{{count}} hidden recommendations — click to show",
  "showRecommendationsCount_one": "{{count}} hidden recommendation — click to show",
  "showRecommendationsCount_other": "{{count}} hidden recommendations — click to show",
  "hiddenCount": "{{count}} hidden",
  "bansOnRecord": "{{count}} bans on record",
  "bansOnRecord_one": "{{count}} ban on record",
  "bansOnRecord_other": "{{count}} bans on record",
  "rollbackConfirmDeadline": " You have {{time}} to confirm before auto-rollback.",
  "ipBlockedWithDeadline": "{{ip}} blocked.{{deadline}}",
  "v3Core": "v3 Core",
  "v4Dashboard": "v4 Dashboard",
  "countries": "Countries:",
  "regions": "Regions:",
  "eGAdmin": "e.g. admin",
  "iPSource": "IP / Source",
  "firewallRulesRemoved": "Removed {{count}} firewall rules",
  "firewallRulesRemoved_one": "Removed {{count}} firewall rule",
  "firewallRulesRemoved_other": "Removed {{count}} firewall rules",
  "hardeningApplied": "{{label}} applied — {{count}} rules added to QBX_ENFORCEMENT",
  "hardeningApplied_one": "{{label}} applied — {{count}} rule added to QBX_ENFORCEMENT",
  "hardeningApplied_other": "{{label}} applied — {{count}} rules added to QBX_ENFORCEMENT",
  "labelRenamed": "Renamed \"{{oldLabel}}\" → \"{{newLabel}}\" ({{count}} rules)",
  "labelRenamed_one": "Renamed \"{{oldLabel}}\" → \"{{newLabel}}\" ({{count}} rule)",
  "labelRenamed_other": "Renamed \"{{oldLabel}}\" → \"{{newLabel}}\" ({{count}} rules)",
  "labelRemovedFromRules": "Removed label \"{{label}}\" from {{count}} rules",
  "labelRemovedFromRules_one": "Removed label \"{{label}}\" from {{count}} rule",
  "labelRemovedFromRules_other": "Removed label \"{{label}}\" from {{count}} rules",
  "labelApplied": "Label \"{{label}}\" applied.",
  "selectDeletableCount": "Select all deletable ({{count}})",
  "removeSelectedItems": "Remove {{count}} selected",
  "failedToToggleGeo-Block": "Failed to toggle geo-block",
  "failedToUpdateMode": "Failed to update mode",
  "failedToDisable": "Failed to disable",
  "noIpsHaveBeenBannedYet.": "No IPs have been banned yet.",
  "noResultsMatchYourCurrentFilters.": "No results match your current filters.",
  "theRestricted-ShellConfigCouldNotBeRead;LshellMayNotBeI": "The restricted-shell config could not be read; lshell may not be installed.",
  "exampleValue": "e.g. {{value}}",
  "exampleAlternatives": "e.g. {{first}} or {{second}}",
  "lastUpdatedValue": "Last updated: {{date}}",
  "aliasPlaceholder": "alias",
  "commandPlaceholder": "command",
  "currentlyFailedCount": "{{count}} failing",
  "currentBanCount": "{{count}} banned now",
  "fallbackIp": "this IP"
} as const;
